import React from 'react';
import * as S from './TimeDropdown.styles';
import { generateTimeList, getTodaysDate } from "../../../../../shared/config/utils";
interface ITime {
  date: Date;
  time: string;
  updateTime: (time, isPickup) => void;
  isPickup: boolean;
  initialTime?: Date
}

const TimeDropdown: React.FC<ITime> = ({
  date = new Date(),
  time = '',
  updateTime = () => {},
  isPickup = true,
  initialTime = null
}) => {
  const isToday = new Date().toDateString() === date.toDateString();
  let timeList = generateTimeList();
  if (isToday) {
    const defaultDate = getTodaysDate();
    timeList = generateTimeList(defaultDate.getHours(), defaultDate.getMinutes());
  }
  if (initialTime) {
    const loc = timeList.indexOf(initialTime);
    timeList = timeList?.filter((_, index) => index >= loc);
  }
  return (
    <S.TimeDropdown>
      <ul>
        {timeList.map((data, index) => <li key={'timer' + index} onClick={()=> updateTime(data, isPickup)}><span>{data}</span>{data === time ? <S.TickIcon >&#10003;</S.TickIcon> : null}</li>) || null}
      </ul>
    </S.TimeDropdown>
  );
};
export default React.memo(TimeDropdown);